<!-- 加载中 -->
<template lang="html">
  <div class="loading" v-show="show">
    <div class="loadingModel">
      <img src="../assets/loading.gif" alt="">
      <p>上传中...</p>
    </div>
  </div>
</template>

<script>
export default {
  props:['show']
}
</script>

<style lang="css" scoped>
.loading{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  z-index:999999;
  top: 0;
  left: 0;
}
.loadingModel img{
  width: 60px;
}
.loadingModel p{
  font-size: 14px;
  color: #fff;
  opacity: 0.8;
}
.loadingModel{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue